// Linha do tempo das execuções do piloto.
import { ArrowUpRight, Clock, Eye, PauseCircle, ShieldCheck } from 'lucide-react'
import type { AutopilotRunDto, AutopilotRunLogEntry } from '@impulso/shared/api/autopilot'
import { ErrorState, Loading } from '../../ui'
import { useAutopilotRuns } from './api'

const TRIGGER: Record<AutopilotRunDto['trigger'], string> = { metrics_updated: 'Dados novos', daily: 'Revisão diária', manual: 'Pedido por você', simulation: 'Simulação' }
const OUTCOME: Record<AutopilotRunLogEntry['outcome'], { label: string; icon: typeof Clock; cls: string }> = {
  executed: { label: 'Feito', icon: ArrowUpRight, cls: 'green' },
  recommended: { label: 'Virou sugestão', icon: Clock, cls: 'blue' },
  blocked: { label: 'Barrado', icon: ShieldCheck, cls: 'amber' },
  conflict: { label: 'Adiado', icon: PauseCircle, cls: 'amber' },
  shadow: { label: 'Só observado', icon: Eye, cls: 'purple' },
  alert: { label: 'Alerta', icon: ShieldCheck, cls: 'red' },
}

export default function RunsTimeline({ companyId }: { companyId: string }) {
  const q = useAutopilotRuns(companyId)
  if (q.isLoading) return <Loading lines={4} />
  if (q.isError) return <ErrorState error={q.error} onRetry={() => void q.refetch()} />
  const runs = q.data?.items ?? []
  if (!runs.length) return <p className="small muted mt-12">O piloto ainda não rodou. Ele analisa sempre que chegam dados novos e todo dia às 7h.</p>
  return (
    <div className="list mt-16">
      {runs.map((r) => (
        <div className="list-item" key={r.id} style={{ flexDirection: 'column', alignItems: 'stretch', gap: 6 }}>
          <div className="row wrap small" style={{ gap: 8 }}>
            <span className="strong">{new Date(r.startedAt).toLocaleString('pt-BR', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' })}</span>
            <span className="muted">{TRIGGER[r.trigger]}</span>
            <span className="muted">· {r.executed} feitas · {r.recommended} sugestões · {r.blocked} barradas</span>
          </div>
          {r.log.slice(0, 6).map((l, i) => {
            const o = OUTCOME[l.outcome]
            return (
              <div className="row small" key={i} style={{ gap: 8, alignItems: 'flex-start' }}>
                <span className={`ic ${o.cls}`} style={{ width: 24, height: 24 }}><o.icon size={12} /></span>
                <div style={{ minWidth: 0 }}>
                  <span className="strong">{o.label}:</span> <span style={{ overflowWrap: 'anywhere' }}>{l.title}</span>
                  {l.reason && l.outcome !== 'executed' && <div className="muted">{l.reason}</div>}
                </div>
              </div>
            )
          })}
          {r.log.length > 6 && <div className="small muted">… e mais {r.log.length - 6}.</div>}
          {r.notes.slice(0, 2).map((n) => <div className="small muted" key={n}>{n}</div>)}
        </div>
      ))}
    </div>
  )
}
